// components/SharePopover.jsx
import { MantineProvider, Popover } from '@mantine/core'
import { ShareIcon } from '@heroicons/react/24/outline'
import { useState } from 'react'

const SharePopover = ({ url }) => {
  const [copySuccess, setCopySuccess] = useState('')

  const copyToClipboard = () => {
    navigator.clipboard.writeText(url).then(
      () => {
        setCopySuccess('Copied!')
        setTimeout(() => setCopySuccess(''), 2000) // Reset the message after 2 seconds
      },
      (err) => {
        setCopySuccess('Failed to copy!')
      }
    )
  }

  return (
    <MantineProvider>
      <Popover className="relative" position="top" withArrow shadow="md">
        <Popover.Target className="flex items-center justify-center p-2 text-gray-500 hover:text-gray-700 focus:outline-none">
          <ShareIcon className="w-[2.5rem] h-12 cursor-pointer" />
        </Popover.Target>

        <Popover.Dropdown anchor="top" className="absolute z-10 w-48 bg-white rounded-lg shadow-lg p-4 mt-2">
          <div className="flex flex-col space-y-2">
            <a
              href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-2 text-gray-700 hover:text-gray-900"
            >
              <i className="fab fa-facebook"></i>
              <span>Facebook</span>
            </a>
            <a
              href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-2 text-gray-700 hover:text-gray-900"
            >
              <i className="fab fa-twitter"></i>
              <span>Twitter</span>
            </a>
            <a
              href={`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(url)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-2 text-gray-700 hover:text-gray-900"
            >
              <i className="fab fa-linkedin"></i>
              <span>LinkedIn</span>
            </a>
            <a
              href={`mailto:?subject=Check this out&body=${encodeURIComponent(url)}`}
              className="flex items-center space-x-2 text-gray-700 hover:text-gray-900"
            >
              <i className="fas fa-envelope"></i>
              <span>Email</span>
            </a>
            <button
              onClick={copyToClipboard}
              className="flex items-center space-x-2 text-gray-700 hover:text-gray-900 focus:outline-none"
            >
              <i className="fas fa-copy"></i>
              <span>{copySuccess ? copySuccess : 'Copy Link'}</span>
            </button>
          </div>
        </Popover.Dropdown>
      </Popover>
    </MantineProvider>
  )
}

export default SharePopover
